export default function () {
  return [
    { key: 'registrationTime', type: "dateRange", props: {mode:"date"} },
    {
      key: 'executorIds',
      label: 'user',
      type: 'user',
      props: {
        clearable: true,
        multiple: true
      }
    },
    { key: 'action', type: 'activity', selectProps: { clearable: true, multiple: false } },

  ]
}
